import React, { Component } from "react";
import { IntroPage } from "app/components/IntroPage";


import './DynamicDemoHomeComponent.scss';

class DynamicDemoHome extends Component{
    render() {		
        return (
            <IntroPage headerText="Dynamic Demographics">                
                <b>Here you can</b>
                <ul className="introHomeItems">
					<li>Create new Dynamic Demographics</li>					
                </ul>
            </IntroPage>
        )
    }
}

export default DynamicDemoHome;